import React from 'react';

function ProgressBar({ label, value, barColor = 'bg-green-600', target }) {
  const percent = Math.max(0, Math.min(value, 100));
  const targetPercent =
    target === null || target === undefined ? null : Math.max(0, Math.min(target, 100));
  let displayValue;

  if (value === null || value === undefined || Number.isNaN(value) || value < 0) {
    displayValue = 'No Data';
  } else if (value > 100) {
    displayValue = '>100%';
  } else {
    displayValue = `${value.toFixed(1)}%`;
  }

  return (
    <div className="mb-6">
      <div className="flex justify-between text-xs font-semibold mb-1">
        <span>{label}</span>
        <span>{displayValue}</span>
      </div>
      <div className="relative w-full h-4">
        <div className="w-full bg-gray-700 rounded-full h-full overflow-hidden">
          <div
            className={`h-full ${barColor} rounded-full`}
            style={{ width: `${percent}%` }}
          />
        </div>
        {targetPercent !== null && (
          <>
            <div
              className="absolute top-0 bottom-0 bg-red-500 w-0.5 z-10"
              style={{ left: `${targetPercent}%` }}
            />
            <div
              className="absolute top-full mt-1 text-xs text-red-500 -translate-x-1/2 z-10"
              style={{ left: `${targetPercent}%` }}
            >
              {`${targetPercent}%`}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ProgressBar;
